export const isUserIdSelector = (state) => state.userReducer.user_details.id;

export const selectUser = (state) => state.userReducer.user_details;
export const selectVideosListingLoading = (state) => state.loadingReducer.videos_listing_loading;
export const selectAnnotationsListingLoading = (state) => state.loadingReducer.annotations_listing_loading;
